import { createTheme } from '@mui/material';

export const defaultTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#21634b',
        },
        secondary: {
            main: '#c89537',
        },
    },
});
